/**
 * @class ExampleComponent
 */

import * as React from 'react'

export type Props = {
  onFilterTextChange: (e:any)=>void
}

export default class ExampleComponent extends React.Component<Props> {
  render() {
    return(
      <form>
        <input
          type="text"
          placeholder="Search..."
          // value={this.props.filterText}
          onKeyUp={event => this.props.onFilterTextChange(event.target['value'])}
        />
      </form>
    );
  }
}
